import { STORAGE_NAMES } from '../../Constant/storage'
import { isLocalStorageEnabled } from '../windowHelpers/windowHelpers'

/**
 * Retrieves the temporary email address stored during the email link sign-in
 *
 * @param getCookie
 * @returns The stored email address, or empty string.
 */
export const getStoredTempEmail = (
  getCookie: (name: string) => string | null
): string => {
  let email = ''

  if (typeof window !== 'undefined' && window.localStorage) {
    email = window.localStorage.getItem(STORAGE_NAMES.tempEmail) || ''
  }
  if (!email) {
    const cookieEm = getCookie(STORAGE_NAMES.tempEmail)
    if (cookieEm) {
      email = cookieEm
    }
  }

  return email.toLowerCase()
}

/**
 * Stores the temporary email address for the email link sign-in
 *
 * @param email
 * @param setCookie A function to set a cookie value.
 */
export const setStoredTempEmail = (
  email: string,
  setCookie: (name: string, value: string) => void
): void => {
  if (isLocalStorageEnabled()) {
    window.localStorage.setItem(STORAGE_NAMES.tempEmail, email)
  }
  setCookie(STORAGE_NAMES.tempEmail, email)
}

/**
 * Removes the temporary email address from all storage locations.
 *
 * @param removeCookie A function to remove a cookie by name.
 */
export const removeStoredTempEmail = (removeCookie: (name: string) => void): void => {
  if (isLocalStorageEnabled()) {
    window.localStorage.removeItem(STORAGE_NAMES.tempEmail)
  }
  removeCookie(STORAGE_NAMES.tempEmail)
}
